import {
  ConditionalValueDto as ApiConditionalValueDto,
  SaveConditionalValue as ApiSaveConditionalValue,
} from 'workflow-definition/openapi';

/**
 * Extended API types that include componentRefId (not yet in the generated API spec).
 */
export interface ConditionalValueDto extends ApiConditionalValueDto {
  componentRefId?: number | null;
}

export interface SaveConditionalValue extends ApiSaveConditionalValue {
  componentRefId?: number | null;
}

export type TriggerEnum = 'Default' | 'Conditional';

export const TriggerEnum = {
  Default: 'Default' as TriggerEnum,
  Conditional: 'Conditional' as TriggerEnum,
};

export type ComparisonOperatorEnum =
  | 'Equal'
  | 'NotEqual'
  | 'GreaterThan'
  | 'GreaterThanOrEqual'
  | 'LessThan'
  | 'LessThanOrEqual'
  | 'IsCompleted'
  | 'IsIncomplete';

export type LogicalOperatorEnum = 'And' | 'Or';

export interface ValueStructure {
  segmentRefId?: null | number;
  stepRefId?: null | number;
  actionRefId?: null | number;
  componentRefId?: null | number;
  jsonFieldId?: null | number;
  fixedValue?: null | string;
  propertyName?: null | string;
  label?: null | string;
}

export interface RuleStructure {
  conditionalRule: {
    id?: number | null;
    order?: number;
    val1?: ValueStructure;
    comp: { value?: ComparisonOperatorEnum };
    val2?: ValueStructure;
    opr?: LogicalOperatorEnum;
  };
}

export interface TriggerStructure {
  conditionalGroup: {
    id?: number | null;
    order?: number;
    opr?: LogicalOperatorEnum;
    rules?: RuleStructure[] | null;
  };
}

export interface TriggersFormStructure {
  triggers: TriggerStructure[];
}

export enum TriggerTypes {
  GEOFENCE_TRIGGER = 'GEOTRI',
  BUTTON_TRIGGER = 'BUTTRI',
  STEP_COMPLETED = 'STEPCOMPL',
  SEGMENT_COMPLETED = 'SGMTCOMPL',
}

export const TriggerDropdownOptions = [
  { label: 'Geofence Trigger', value: TriggerTypes.GEOFENCE_TRIGGER },
  { label: 'Button Trigger', value: TriggerTypes.BUTTON_TRIGGER },
  { label: 'Step Completed', value: TriggerTypes.STEP_COMPLETED },
  { label: 'Segment Completed', value: TriggerTypes.SEGMENT_COMPLETED },
];

export const EventDropdownOptions = [
  { label: 'Arrival', value: 'ARRIVE' },
  { label: 'Departure', value: 'DEPART' },
  { label: 'Miles away', value: 'MILESAWAY' },
];
